/**
 * 交流合作专区 专家访谈 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/thinkTank/expertInterview/page`, { params: data })
  },
  getDetail: (id, data) => {
    return request.get(`/api/frLegalPlatform/web/thinkTank/expertInterview/${id}`, { params: data })
  }
}
